export enum OrderType {
  Seat = 'seat',
  Away = 'away',
  Delivery = 'delivery',
}
export enum OrderStatus {
  Received = 'received',
  Progress = 'progress',
  ReadyToTake = 'readyta',
  Delivering = 'delivering',
  Finished = 'finished',
  Declined = 'declined',
  Canceled = 'canceled',
}
export enum OrderPaymentType {
  Store = 'store',
  Online = 'online',
}
export enum OrderPaymentStatus {
  Awaiting = 'await',
  Paid = 'paid',
  Declined = 'declined',
  Reimbursed = 'reimbursed',
  Partial = 'partial',
}
export enum OrderMode {
  Native = 'native',
  WhatsApp = 'wa',
}
export const OrderStatusColor = {
  [OrderStatus.Received]: '#e06f18',
  [OrderStatus.Progress]: 'orange',
  [OrderStatus.Delivering]: 'purple',
  [OrderStatus.ReadyToTake]: 'blue',
  [OrderStatus.Finished]: 'green',
  [OrderStatus.Declined]: 'red',
  [OrderStatus.Canceled]: 'red',
};
export const OrderPaymentStatusColor = {
  [OrderPaymentStatus.Awaiting]: 'grey',
  [OrderPaymentStatus.Paid]: 'green',
  [OrderPaymentStatus.Declined]: 'red',
  [OrderPaymentStatus.Reimbursed]: 'red',
};
